import { Injectable } from '@angular/core';
import { ServerRootService } from '@se/se.ui.html5';
import { EstensaPatientFolderService } from './angularjs/estensa-patient-folder.service';
import { AuthData } from '../confirm/auth-data';
import { RadioEprEvent } from 'estensa-module';

@Injectable({
    providedIn: 'root',
})
export class PatientHistoryService extends ServerRootService {
    constructor(private patientFolderService: EstensaPatientFolderService) {
        super();
    }

    getAllEprEvents(patientId: string, AllBUSearch: boolean, credentials?: AuthData) {
        return this.patientFolderService.getPatientReportsNg2(patientId, AllBUSearch,credentials,false);
    }

}

export interface IEprEventsWithErrorMessage {
    displayMessage: string;
    exceptionMessage: string;
    eprEvents: RadioEprEvent[];
}
